import { AccordionItem, Text, List, Strong } from 'braid-design-system';
export const Branding = () => (
  <AccordionItem id="branding" label="Branding">
    <List type="number" start={14}>
      <Text>
        Subject to these Terms, the relevant members of the SEEK Group grant you
        a limited, non-exclusive, non-assignable, non-transferable and
        non-sublicensable licence (<Strong>Brand Licence</Strong>) solely for
        the purpose of displaying the SEEK Group Branding within your
        Recruitment Software for the duration of the Term.
      </Text>
      <Text>
        For any use of the SEEK Group Branding other than provided for under the
        Brand Licence, you must obtain our prior written approval before such
        use.
      </Text>
      <Text>
        You must use the SEEK Group Branding in accordance with the SEEK Group
        Branding Guidelines, which will be provided to you.
      </Text>
      <Text>
        You grant the SEEK Group a limited, non-exclusive, non-assignable,
        non-transferable and non-sublicensable licence during the Term to
        display your logos, trade marks, business name and domain names to
        advertise your Recruitment Software or your use of the SEEK API on our
        websites and apps.
      </Text>
      <Text>
        The SEEK Group may publish your brand (name and logo) on our websites
        and apps, in promotional materials including press releases without
        additional consent or notice to you.
      </Text>
    </List>
  </AccordionItem>
);
